/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateUserInput = {
  id?: string | null,
  accountID: string,
  conceptID?: string | null,
  username?: string | null,
  email?: string | null,
  email_verified?: boolean | null,
  phone_number?: string | null,
  phone_number_verified?: boolean | null,
  name?: string | null,
  nickname?: string | null,
  given_name?: string | null,
  middle_name?: string | null,
  family_name?: string | null,
  address?: string | null,
  birthdate?: string | null,
  gender?: string | null,
  picture?: string | null,
  website?: string | null,
  verification_code?: string | null,
  facebook?: string | null,
  instagram?: string | null,
  group?: string | null,
  phones?: Array< string | null > | null,
  status?: string | null,
  stats?: Array< string | null > | null,
  total_points?: number | null,
  points_history?: Array< string | null > | null,
  tier?: string | null,
  tier_name?: string | null,
  points_balance?: number | null,
  total_spending?: number | null,
  orders_count?: number | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelUserConditionInput = {
  accountID?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  email?: ModelStringInput | null,
  email_verified?: ModelBooleanInput | null,
  phone_number?: ModelStringInput | null,
  phone_number_verified?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  nickname?: ModelStringInput | null,
  given_name?: ModelStringInput | null,
  middle_name?: ModelStringInput | null,
  family_name?: ModelStringInput | null,
  address?: ModelStringInput | null,
  birthdate?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  picture?: ModelStringInput | null,
  website?: ModelStringInput | null,
  verification_code?: ModelStringInput | null,
  facebook?: ModelStringInput | null,
  instagram?: ModelStringInput | null,
  group?: ModelStringInput | null,
  phones?: ModelStringInput | null,
  status?: ModelStringInput | null,
  stats?: ModelIDInput | null,
  total_points?: ModelIntInput | null,
  points_history?: ModelIDInput | null,
  tier?: ModelIDInput | null,
  tier_name?: ModelStringInput | null,
  points_balance?: ModelFloatInput | null,
  total_spending?: ModelFloatInput | null,
  orders_count?: ModelIntInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type User = {
  __typename: "User",
  id: string,
  accountID: string,
  conceptID?: string | null,
  username?: string | null,
  email?: string | null,
  email_verified?: boolean | null,
  phone_number?: string | null,
  phone_number_verified?: boolean | null,
  name?: string | null,
  nickname?: string | null,
  given_name?: string | null,
  middle_name?: string | null,
  family_name?: string | null,
  address?: string | null,
  birthdate?: string | null,
  gender?: string | null,
  picture?: string | null,
  website?: string | null,
  verification_code?: string | null,
  facebook?: string | null,
  instagram?: string | null,
  group?: string | null,
  phones?: Array< string | null > | null,
  status?: string | null,
  stats?: Array< string | null > | null,
  total_points?: number | null,
  points_history?: Array< string | null > | null,
  tier?: string | null,
  tier_name?: string | null,
  points_balance?: number | null,
  total_spending?: number | null,
  orders_count?: number | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateUserInput = {
  id: string,
  accountID?: string | null,
  conceptID?: string | null,
  username?: string | null,
  email?: string | null,
  email_verified?: boolean | null,
  phone_number?: string | null,
  phone_number_verified?: boolean | null,
  name?: string | null,
  nickname?: string | null,
  given_name?: string | null,
  middle_name?: string | null,
  family_name?: string | null,
  address?: string | null,
  birthdate?: string | null,
  gender?: string | null,
  picture?: string | null,
  website?: string | null,
  verification_code?: string | null,
  facebook?: string | null,
  instagram?: string | null,
  group?: string | null,
  phones?: Array< string | null > | null,
  status?: string | null,
  stats?: Array< string | null > | null,
  total_points?: number | null,
  points_history?: Array< string | null > | null,
  tier?: string | null,
  tier_name?: string | null,
  points_balance?: number | null,
  total_spending?: number | null,
  orders_count?: number | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateAccountInput = {
  id?: string | null,
  domain: string,
  siteTitle: string,
  guestsCount?: number | null,
  tagline: string,
  description: string,
  siteAddress: string,
  defaultLanguage: string,
  languages: Array< string | null >,
  features: Array< string | null >,
  status: string,
  socialLinks?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  callCenterEmployeesIds?: Array< string | null > | null,
  _version?: number | null,
  accountLogoId?: string | null,
};

export type ModelAccountConditionInput = {
  domain?: ModelStringInput | null,
  siteTitle?: ModelStringInput | null,
  guestsCount?: ModelIntInput | null,
  tagline?: ModelStringInput | null,
  description?: ModelStringInput | null,
  siteAddress?: ModelStringInput | null,
  defaultLanguage?: ModelStringInput | null,
  languages?: ModelStringInput | null,
  features?: ModelStringInput | null,
  status?: ModelStringInput | null,
  socialLinks?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  callCenterEmployeesIds?: ModelStringInput | null,
  and?: Array< ModelAccountConditionInput | null > | null,
  or?: Array< ModelAccountConditionInput | null > | null,
  not?: ModelAccountConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
  accountLogoId?: ModelIDInput | null,
};

export type Account = {
  __typename: "Account",
  id: string,
  logo?: Attachment | null,
  domain: string,
  siteTitle: string,
  guestsCount?: number | null,
  tagline: string,
  description: string,
  siteAddress: string,
  defaultLanguage: string,
  languages: Array< string | null >,
  features: Array< string | null >,
  status: string,
  socialLinks?: Array< string | null > | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  callCenterEmployeesIds?: Array< string | null > | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  accountLogoId?: string | null,
};

export type Attachment = {
  __typename: "Attachment",
  id: string,
  mediaID: string,
  fileUrl: string,
  filename: string,
  filetype?: string | null,
  fileSize?: number | null,
  alternativeText?: string | null,
  caption?: string | null,
  description?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAccountInput = {
  id: string,
  domain?: string | null,
  siteTitle?: string | null,
  guestsCount?: number | null,
  tagline?: string | null,
  description?: string | null,
  siteAddress?: string | null,
  defaultLanguage?: string | null,
  languages?: Array< string | null > | null,
  features?: Array< string | null > | null,
  status?: string | null,
  socialLinks?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  callCenterEmployeesIds?: Array< string | null > | null,
  _version?: number | null,
  accountLogoId?: string | null,
};

export type DeleteAccountInput = {
  id: string,
  _version?: number | null,
};

export type CreateSocialLinkInput = {
  id?: string | null,
  name: string,
  icon: string,
  slug: string,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelSocialLinkConditionInput = {
  name?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelSocialLinkConditionInput | null > | null,
  or?: Array< ModelSocialLinkConditionInput | null > | null,
  not?: ModelSocialLinkConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type SocialLink = {
  __typename: "SocialLink",
  id: string,
  name: string,
  icon: string,
  slug: string,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateSocialLinkInput = {
  id: string,
  name?: string | null,
  icon?: string | null,
  slug?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteSocialLinkInput = {
  id: string,
  _version?: number | null,
};

export type CreateFeatureInput = {
  id?: string | null,
  name: string,
  icon?: string | null,
  slug: string,
  precedence: string,
  parent?: string | null,
  private?: boolean | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelFeatureConditionInput = {
  name?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  precedence?: ModelStringInput | null,
  parent?: ModelStringInput | null,
  private?: ModelBooleanInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelFeatureConditionInput | null > | null,
  or?: Array< ModelFeatureConditionInput | null > | null,
  not?: ModelFeatureConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Feature = {
  __typename: "Feature",
  id: string,
  name: string,
  icon?: string | null,
  slug: string,
  precedence: string,
  parent?: string | null,
  private?: boolean | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateFeatureInput = {
  id: string,
  name?: string | null,
  icon?: string | null,
  slug?: string | null,
  precedence?: string | null,
  parent?: string | null,
  private?: boolean | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteFeatureInput = {
  id: string,
  _version?: number | null,
};

export type CreateLanguageInput = {
  id?: string | null,
  name: string,
  code: string,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelLanguageConditionInput = {
  name?: ModelStringInput | null,
  code?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelLanguageConditionInput | null > | null,
  or?: Array< ModelLanguageConditionInput | null > | null,
  not?: ModelLanguageConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Language = {
  __typename: "Language",
  id: string,
  name: string,
  code: string,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateLanguageInput = {
  id: string,
  name?: string | null,
  code?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteLanguageInput = {
  id: string,
  _version?: number | null,
};

export type CreateMediaInput = {
  id?: string | null,
  accountID: string,
  fileUrl: string,
  filename: string,
  filetype?: string | null,
  fileSize?: number | null,
  alternativeText?: string | null,
  caption?: string | null,
  description?: string | null,
  attachments?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelMediaConditionInput = {
  accountID?: ModelIDInput | null,
  fileUrl?: ModelStringInput | null,
  filename?: ModelStringInput | null,
  filetype?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  alternativeText?: ModelStringInput | null,
  caption?: ModelStringInput | null,
  description?: ModelStringInput | null,
  attachments?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelMediaConditionInput | null > | null,
  or?: Array< ModelMediaConditionInput | null > | null,
  not?: ModelMediaConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Media = {
  __typename: "Media",
  id: string,
  accountID: string,
  fileUrl: string,
  filename: string,
  filetype?: string | null,
  fileSize?: number | null,
  alternativeText?: string | null,
  caption?: string | null,
  description?: string | null,
  attachments?: Array< string | null > | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateMediaInput = {
  id: string,
  accountID?: string | null,
  fileUrl?: string | null,
  filename?: string | null,
  filetype?: string | null,
  fileSize?: number | null,
  alternativeText?: string | null,
  caption?: string | null,
  description?: string | null,
  attachments?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteMediaInput = {
  id: string,
  _version?: number | null,
};

export type CreateAttachmentInput = {
  id?: string | null,
  mediaID: string,
  fileUrl: string,
  filename: string,
  filetype?: string | null,
  fileSize?: number | null,
  alternativeText?: string | null,
  caption?: string | null,
  description?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelAttachmentConditionInput = {
  mediaID?: ModelIDInput | null,
  fileUrl?: ModelStringInput | null,
  filename?: ModelStringInput | null,
  filetype?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  alternativeText?: ModelStringInput | null,
  caption?: ModelStringInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelAttachmentConditionInput | null > | null,
  or?: Array< ModelAttachmentConditionInput | null > | null,
  not?: ModelAttachmentConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAttachmentInput = {
  id: string,
  mediaID?: string | null,
  fileUrl?: string | null,
  filename?: string | null,
  filetype?: string | null,
  fileSize?: number | null,
  alternativeText?: string | null,
  caption?: string | null,
  description?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteAttachmentInput = {
  id: string,
  _version?: number | null,
};

export type CreateConceptInput = {
  id?: string | null,
  accountID: string,
  name: string,
  kiosks?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelConceptConditionInput = {
  accountID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  kiosks?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelConceptConditionInput | null > | null,
  or?: Array< ModelConceptConditionInput | null > | null,
  not?: ModelConceptConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Concept = {
  __typename: "Concept",
  id: string,
  accountID: string,
  name: string,
  kiosks?: Array< string | null > | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateConceptInput = {
  id: string,
  accountID?: string | null,
  name?: string | null,
  kiosks?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteConceptInput = {
  id: string,
  _version?: number | null,
};

export type CreateGroupInput = {
  id?: string | null,
  accountID: string,
  name: string,
  description?: string | null,
  color?: string | null,
  requireApproval?: boolean | null,
  status?: string | null,
  agents?: Array< string | null > | null,
  groupSettings?: Array< string | null > | null,
  numToUpgrade?: number | null,
  numToDowngrade?: number | null,
  upgradeGroup?: string | null,
  downgradeGroup?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelGroupConditionInput = {
  accountID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  color?: ModelStringInput | null,
  requireApproval?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  agents?: ModelStringInput | null,
  groupSettings?: ModelStringInput | null,
  numToUpgrade?: ModelIntInput | null,
  numToDowngrade?: ModelIntInput | null,
  upgradeGroup?: ModelIDInput | null,
  downgradeGroup?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelGroupConditionInput | null > | null,
  or?: Array< ModelGroupConditionInput | null > | null,
  not?: ModelGroupConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Group = {
  __typename: "Group",
  id: string,
  accountID: string,
  name: string,
  description?: string | null,
  color?: string | null,
  requireApproval?: boolean | null,
  status?: string | null,
  agents?: Array< string | null > | null,
  groupSettings?: Array< string | null > | null,
  numToUpgrade?: number | null,
  numToDowngrade?: number | null,
  upgradeGroup?: string | null,
  downgradeGroup?: string | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateGroupInput = {
  id: string,
  accountID?: string | null,
  name?: string | null,
  description?: string | null,
  color?: string | null,
  requireApproval?: boolean | null,
  status?: string | null,
  agents?: Array< string | null > | null,
  groupSettings?: Array< string | null > | null,
  numToUpgrade?: number | null,
  numToDowngrade?: number | null,
  upgradeGroup?: string | null,
  downgradeGroup?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteGroupInput = {
  id: string,
  _version?: number | null,
};

export type CreateGroupSettingInput = {
  id?: string | null,
  groupID: string,
  statusID: string,
  needsVerification: boolean,
  needsDeposit: boolean,
  isDefault: boolean,
  amount?: number | null,
  days?: Array< string | null > | null,
  timeSlots?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelGroupSettingConditionInput = {
  groupID?: ModelStringInput | null,
  statusID?: ModelIDInput | null,
  needsVerification?: ModelBooleanInput | null,
  needsDeposit?: ModelBooleanInput | null,
  isDefault?: ModelBooleanInput | null,
  amount?: ModelIntInput | null,
  days?: ModelStringInput | null,
  timeSlots?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelGroupSettingConditionInput | null > | null,
  or?: Array< ModelGroupSettingConditionInput | null > | null,
  not?: ModelGroupSettingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type GroupSetting = {
  __typename: "GroupSetting",
  id: string,
  groupID: string,
  statusID: string,
  needsVerification: boolean,
  needsDeposit: boolean,
  isDefault: boolean,
  amount?: number | null,
  days?: Array< string | null > | null,
  timeSlots?: Array< string | null > | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateGroupSettingInput = {
  id: string,
  groupID?: string | null,
  statusID?: string | null,
  needsVerification?: boolean | null,
  needsDeposit?: boolean | null,
  isDefault?: boolean | null,
  amount?: number | null,
  days?: Array< string | null > | null,
  timeSlots?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteGroupSettingInput = {
  id: string,
  _version?: number | null,
};

export type CreateTimelineInput = {
  id?: string | null,
  actionName: string,
  oldStatus: string,
  newStatus: string,
  bookingId?: string | null,
  customerId?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelTimelineConditionInput = {
  actionName?: ModelStringInput | null,
  oldStatus?: ModelStringInput | null,
  newStatus?: ModelStringInput | null,
  bookingId?: ModelStringInput | null,
  customerId?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelTimelineConditionInput | null > | null,
  or?: Array< ModelTimelineConditionInput | null > | null,
  not?: ModelTimelineConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Timeline = {
  __typename: "Timeline",
  id: string,
  actionName: string,
  oldStatus: string,
  newStatus: string,
  bookingId?: string | null,
  customerId?: string | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTimelineInput = {
  id: string,
  actionName?: string | null,
  oldStatus?: string | null,
  newStatus?: string | null,
  bookingId?: string | null,
  customerId?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteTimelineInput = {
  id: string,
  _version?: number | null,
};

export type CreateAdminRoleInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelAdminRoleConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelAdminRoleConditionInput | null > | null,
  or?: Array< ModelAdminRoleConditionInput | null > | null,
  not?: ModelAdminRoleConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AdminRole = {
  __typename: "AdminRole",
  id: string,
  name?: string | null,
  description?: string | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAdminRoleInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteAdminRoleInput = {
  id: string,
  _version?: number | null,
};

export type CreateAdminGroupInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  roles?: Array< string | null > | null,
  users?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelAdminGroupConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  roles?: ModelIDInput | null,
  users?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelAdminGroupConditionInput | null > | null,
  or?: Array< ModelAdminGroupConditionInput | null > | null,
  not?: ModelAdminGroupConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AdminGroup = {
  __typename: "AdminGroup",
  id: string,
  name?: string | null,
  description?: string | null,
  roles?: Array< string | null > | null,
  users?: Array< string | null > | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateAdminGroupInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  roles?: Array< string | null > | null,
  users?: Array< string | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteAdminGroupInput = {
  id: string,
  _version?: number | null,
};

export type CreatePointInput = {
  id?: string | null,
  accountID: string,
  amount?: number | null,
  expiry_date?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelPointConditionInput = {
  accountID?: ModelStringInput | null,
  amount?: ModelIntInput | null,
  expiry_date?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelPointConditionInput | null > | null,
  or?: Array< ModelPointConditionInput | null > | null,
  not?: ModelPointConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Point = {
  __typename: "Point",
  id: string,
  accountID: string,
  amount?: number | null,
  expiry_date?: string | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdatePointInput = {
  id: string,
  accountID?: string | null,
  amount?: number | null,
  expiry_date?: string | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeletePointInput = {
  id: string,
  _version?: number | null,
};

export type CreateTierInput = {
  id?: string | null,
  accountID: string,
  conceptID?: string | null,
  name: string,
  description?: string | null,
  imageUrl?: string | null,
  starting_value: number,
  is_points_expire?: boolean | null,
  welcome_points?: number | null,
  points_gain_factor?: number | null,
  money_redeem_factor?: number | null,
  days_to_expire?: number | null,
  discount_rate?: number | null,
  discount_simphony_id?: string | null,
  customerCount: number,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type ModelTierConditionInput = {
  accountID?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  starting_value?: ModelIntInput | null,
  is_points_expire?: ModelBooleanInput | null,
  welcome_points?: ModelIntInput | null,
  points_gain_factor?: ModelFloatInput | null,
  money_redeem_factor?: ModelFloatInput | null,
  days_to_expire?: ModelIntInput | null,
  discount_rate?: ModelIntInput | null,
  discount_simphony_id?: ModelStringInput | null,
  customerCount?: ModelIntInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelTierConditionInput | null > | null,
  or?: Array< ModelTierConditionInput | null > | null,
  not?: ModelTierConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Tier = {
  __typename: "Tier",
  id: string,
  accountID: string,
  conceptID?: string | null,
  name: string,
  description?: string | null,
  imageUrl?: string | null,
  starting_value: number,
  is_points_expire?: boolean | null,
  welcome_points?: number | null,
  points_gain_factor?: number | null,
  money_redeem_factor?: number | null,
  days_to_expire?: number | null,
  discount_rate?: number | null,
  discount_simphony_id?: string | null,
  customerCount: number,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateTierInput = {
  id: string,
  accountID?: string | null,
  conceptID?: string | null,
  name?: string | null,
  description?: string | null,
  imageUrl?: string | null,
  starting_value?: number | null,
  is_points_expire?: boolean | null,
  welcome_points?: number | null,
  points_gain_factor?: number | null,
  money_redeem_factor?: number | null,
  days_to_expire?: number | null,
  discount_rate?: number | null,
  discount_simphony_id?: string | null,
  customerCount?: number | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteTierInput = {
  id: string,
  _version?: number | null,
};

export type CreateTransactionInput = {
  id?: string | null,
  accountID: string,
  conceptID?: string | null,
  customerID: string,
  customerName?: string | null,
  checkNumber: string,
  orderTotal: string,
  paidAmount?: number | null,
  discountAmount?: number | null,
  employeeID?: string | null,
  employeeName?: string | null,
  revenueCentreName?: string | null,
  revenueCentreID?: string | null,
  points?: number | null,
  points_operation?: string | null,
  refundTrx?: boolean | null,
  refundAmount?: number | null,
  paymentStatus?: string | null,
  itemNames?: Array< string | null > | null,
  itemCounts?: Array< number | null > | null,
  orderedItems?: Array< TransactionItemInput | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID: string,
  createdByName: string,
  _version?: number | null,
};

export type TransactionItemInput = {
  symphonyID?: string | null,
  name: string,
  quantity: number,
  unitPrice?: number | null,
  totalPrice: number,
  refunded?: boolean | null,
};

export type ModelTransactionConditionInput = {
  accountID?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  customerID?: ModelStringInput | null,
  customerName?: ModelStringInput | null,
  checkNumber?: ModelStringInput | null,
  orderTotal?: ModelStringInput | null,
  paidAmount?: ModelFloatInput | null,
  discountAmount?: ModelFloatInput | null,
  employeeID?: ModelStringInput | null,
  employeeName?: ModelStringInput | null,
  revenueCentreName?: ModelStringInput | null,
  revenueCentreID?: ModelStringInput | null,
  points?: ModelIntInput | null,
  points_operation?: ModelStringInput | null,
  refundTrx?: ModelBooleanInput | null,
  refundAmount?: ModelFloatInput | null,
  paymentStatus?: ModelStringInput | null,
  itemNames?: ModelStringInput | null,
  itemCounts?: ModelIntInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  and?: Array< ModelTransactionConditionInput | null > | null,
  or?: Array< ModelTransactionConditionInput | null > | null,
  not?: ModelTransactionConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Transaction = {
  __typename: "Transaction",
  id: string,
  accountID: string,
  conceptID?: string | null,
  customerID: string,
  customerName?: string | null,
  checkNumber: string,
  orderTotal: string,
  paidAmount?: number | null,
  discountAmount?: number | null,
  employeeID?: string | null,
  employeeName?: string | null,
  revenueCentreName?: string | null,
  revenueCentreID?: string | null,
  points?: number | null,
  points_operation?: string | null,
  refundTrx?: boolean | null,
  refundAmount?: number | null,
  paymentStatus?: string | null,
  itemNames?: Array< string | null > | null,
  itemCounts?: Array< number | null > | null,
  orderedItems?:  Array<TransactionItem | null > | null,
  deleted?: string | null,
  createdAt: string,
  createdByID: string,
  createdByName: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type TransactionItem = {
  __typename: "TransactionItem",
  symphonyID?: string | null,
  name: string,
  quantity: number,
  unitPrice?: number | null,
  totalPrice: number,
  refunded?: boolean | null,
};

export type UpdateTransactionInput = {
  id: string,
  accountID?: string | null,
  conceptID?: string | null,
  customerID?: string | null,
  customerName?: string | null,
  checkNumber?: string | null,
  orderTotal?: string | null,
  paidAmount?: number | null,
  discountAmount?: number | null,
  employeeID?: string | null,
  employeeName?: string | null,
  revenueCentreName?: string | null,
  revenueCentreID?: string | null,
  points?: number | null,
  points_operation?: string | null,
  refundTrx?: boolean | null,
  refundAmount?: number | null,
  paymentStatus?: string | null,
  itemNames?: Array< string | null > | null,
  itemCounts?: Array< number | null > | null,
  orderedItems?: Array< TransactionItemInput | null > | null,
  deleted?: string | null,
  createdAt?: string | null,
  createdByID?: string | null,
  createdByName?: string | null,
  _version?: number | null,
};

export type DeleteTransactionInput = {
  id: string,
  _version?: number | null,
};

export type CreateOrderedItemsInput = {
  id?: string | null,
  userID: string,
  itemName: string,
  conceptID?: string | null,
  count: number,
  isGlobal?: string | null,
  createdAt?: string | null,
  createdByName?: string | null,
  deleted?: string | null,
  _version?: number | null,
};

export type ModelOrderedItemsConditionInput = {
  userID?: ModelStringInput | null,
  itemName?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  count?: ModelIntInput | null,
  isGlobal?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  and?: Array< ModelOrderedItemsConditionInput | null > | null,
  or?: Array< ModelOrderedItemsConditionInput | null > | null,
  not?: ModelOrderedItemsConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type OrderedItems = {
  __typename: "OrderedItems",
  id: string,
  userID: string,
  itemName: string,
  conceptID?: string | null,
  count: number,
  isGlobal?: string | null,
  createdAt: string,
  createdByName?: string | null,
  deleted?: string | null,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateOrderedItemsInput = {
  id: string,
  userID?: string | null,
  itemName?: string | null,
  conceptID?: string | null,
  count?: number | null,
  isGlobal?: string | null,
  createdAt?: string | null,
  createdByName?: string | null,
  deleted?: string | null,
  _version?: number | null,
};

export type DeleteOrderedItemsInput = {
  id: string,
  _version?: number | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  username?: ModelStringInput | null,
  email?: ModelStringInput | null,
  email_verified?: ModelBooleanInput | null,
  phone_number?: ModelStringInput | null,
  phone_number_verified?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  nickname?: ModelStringInput | null,
  given_name?: ModelStringInput | null,
  middle_name?: ModelStringInput | null,
  family_name?: ModelStringInput | null,
  address?: ModelStringInput | null,
  birthdate?: ModelStringInput | null,
  gender?: ModelStringInput | null,
  picture?: ModelStringInput | null,
  website?: ModelStringInput | null,
  verification_code?: ModelStringInput | null,
  facebook?: ModelStringInput | null,
  instagram?: ModelStringInput | null,
  group?: ModelStringInput | null,
  phones?: ModelStringInput | null,
  status?: ModelStringInput | null,
  stats?: ModelIDInput | null,
  total_points?: ModelIntInput | null,
  points_history?: ModelIDInput | null,
  tier?: ModelIDInput | null,
  tier_name?: ModelStringInput | null,
  points_balance?: ModelFloatInput | null,
  total_spending?: ModelFloatInput | null,
  orders_count?: ModelIntInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelAccountFilterInput = {
  id?: ModelIDInput | null,
  domain?: ModelStringInput | null,
  siteTitle?: ModelStringInput | null,
  guestsCount?: ModelIntInput | null,
  tagline?: ModelStringInput | null,
  description?: ModelStringInput | null,
  siteAddress?: ModelStringInput | null,
  defaultLanguage?: ModelStringInput | null,
  languages?: ModelStringInput | null,
  features?: ModelStringInput | null,
  status?: ModelStringInput | null,
  socialLinks?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  callCenterEmployeesIds?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAccountFilterInput | null > | null,
  or?: Array< ModelAccountFilterInput | null > | null,
  not?: ModelAccountFilterInput | null,
  _deleted?: ModelBooleanInput | null,
  accountLogoId?: ModelIDInput | null,
};

export type ModelAccountConnection = {
  __typename: "ModelAccountConnection",
  items:  Array<Account | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSocialLinkFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSocialLinkFilterInput | null > | null,
  or?: Array< ModelSocialLinkFilterInput | null > | null,
  not?: ModelSocialLinkFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSocialLinkConnection = {
  __typename: "ModelSocialLinkConnection",
  items:  Array<SocialLink | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSocialLinkByNameCompositeKeyConditionInput = {
  eq?: ModelSocialLinkByNameCompositeKeyInput | null,
  le?: ModelSocialLinkByNameCompositeKeyInput | null,
  lt?: ModelSocialLinkByNameCompositeKeyInput | null,
  ge?: ModelSocialLinkByNameCompositeKeyInput | null,
  gt?: ModelSocialLinkByNameCompositeKeyInput | null,
  between?: Array< ModelSocialLinkByNameCompositeKeyInput | null > | null,
  beginsWith?: ModelSocialLinkByNameCompositeKeyInput | null,
};

export type ModelSocialLinkByNameCompositeKeyInput = {
  createdAt?: string | null,
  deleted?: string | null,
};

export type ModelFeatureFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  precedence?: ModelStringInput | null,
  parent?: ModelStringInput | null,
  private?: ModelBooleanInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelFeatureFilterInput | null > | null,
  or?: Array< ModelFeatureFilterInput | null > | null,
  not?: ModelFeatureFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFeatureConnection = {
  __typename: "ModelFeatureConnection",
  items:  Array<Feature | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelFeatureByNameCompositeKeyConditionInput = {
  eq?: ModelFeatureByNameCompositeKeyInput | null,
  le?: ModelFeatureByNameCompositeKeyInput | null,
  lt?: ModelFeatureByNameCompositeKeyInput | null,
  ge?: ModelFeatureByNameCompositeKeyInput | null,
  gt?: ModelFeatureByNameCompositeKeyInput | null,
  between?: Array< ModelFeatureByNameCompositeKeyInput | null > | null,
  beginsWith?: ModelFeatureByNameCompositeKeyInput | null,
};

export type ModelFeatureByNameCompositeKeyInput = {
  createdAt?: string | null,
  deleted?: string | null,
};

export type ModelLanguageFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  code?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLanguageFilterInput | null > | null,
  or?: Array< ModelLanguageFilterInput | null > | null,
  not?: ModelLanguageFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelLanguageConnection = {
  __typename: "ModelLanguageConnection",
  items:  Array<Language | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelLanguageByNameCompositeKeyConditionInput = {
  eq?: ModelLanguageByNameCompositeKeyInput | null,
  le?: ModelLanguageByNameCompositeKeyInput | null,
  lt?: ModelLanguageByNameCompositeKeyInput | null,
  ge?: ModelLanguageByNameCompositeKeyInput | null,
  gt?: ModelLanguageByNameCompositeKeyInput | null,
  between?: Array< ModelLanguageByNameCompositeKeyInput | null > | null,
  beginsWith?: ModelLanguageByNameCompositeKeyInput | null,
};

export type ModelLanguageByNameCompositeKeyInput = {
  createdAt?: string | null,
  deleted?: string | null,
};

export type ModelMediaFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelIDInput | null,
  fileUrl?: ModelStringInput | null,
  filename?: ModelStringInput | null,
  filetype?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  alternativeText?: ModelStringInput | null,
  caption?: ModelStringInput | null,
  description?: ModelStringInput | null,
  attachments?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMediaFilterInput | null > | null,
  or?: Array< ModelMediaFilterInput | null > | null,
  not?: ModelMediaFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelMediaConnection = {
  __typename: "ModelMediaConnection",
  items:  Array<Media | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAttachmentFilterInput = {
  id?: ModelIDInput | null,
  mediaID?: ModelIDInput | null,
  fileUrl?: ModelStringInput | null,
  filename?: ModelStringInput | null,
  filetype?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  alternativeText?: ModelStringInput | null,
  caption?: ModelStringInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAttachmentFilterInput | null > | null,
  or?: Array< ModelAttachmentFilterInput | null > | null,
  not?: ModelAttachmentFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAttachmentConnection = {
  __typename: "ModelAttachmentConnection",
  items:  Array<Attachment | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelConceptFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  kiosks?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelConceptFilterInput | null > | null,
  or?: Array< ModelConceptFilterInput | null > | null,
  not?: ModelConceptFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelConceptConnection = {
  __typename: "ModelConceptConnection",
  items:  Array<Concept | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelConceptByAccountCompositeKeyConditionInput = {
  eq?: ModelConceptByAccountCompositeKeyInput | null,
  le?: ModelConceptByAccountCompositeKeyInput | null,
  lt?: ModelConceptByAccountCompositeKeyInput | null,
  ge?: ModelConceptByAccountCompositeKeyInput | null,
  gt?: ModelConceptByAccountCompositeKeyInput | null,
  between?: Array< ModelConceptByAccountCompositeKeyInput | null > | null,
  beginsWith?: ModelConceptByAccountCompositeKeyInput | null,
};

export type ModelConceptByAccountCompositeKeyInput = {
  createdAt?: string | null,
  deleted?: string | null,
};

export type ModelGroupFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  color?: ModelStringInput | null,
  requireApproval?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  agents?: ModelStringInput | null,
  groupSettings?: ModelStringInput | null,
  numToUpgrade?: ModelIntInput | null,
  numToDowngrade?: ModelIntInput | null,
  upgradeGroup?: ModelIDInput | null,
  downgradeGroup?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelGroupFilterInput | null > | null,
  or?: Array< ModelGroupFilterInput | null > | null,
  not?: ModelGroupFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelGroupConnection = {
  __typename: "ModelGroupConnection",
  items:  Array<Group | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelGroupByAccountCompositeKeyConditionInput = {
  eq?: ModelGroupByAccountCompositeKeyInput | null,
  le?: ModelGroupByAccountCompositeKeyInput | null,
  lt?: ModelGroupByAccountCompositeKeyInput | null,
  ge?: ModelGroupByAccountCompositeKeyInput | null,
  gt?: ModelGroupByAccountCompositeKeyInput | null,
  between?: Array< ModelGroupByAccountCompositeKeyInput | null > | null,
  beginsWith?: ModelGroupByAccountCompositeKeyInput | null,
};

export type ModelGroupByAccountCompositeKeyInput = {
  createdAt?: string | null,
  deleted?: string | null,
};

export type ModelGroupSettingFilterInput = {
  id?: ModelIDInput | null,
  groupID?: ModelStringInput | null,
  statusID?: ModelIDInput | null,
  needsVerification?: ModelBooleanInput | null,
  needsDeposit?: ModelBooleanInput | null,
  isDefault?: ModelBooleanInput | null,
  amount?: ModelIntInput | null,
  days?: ModelStringInput | null,
  timeSlots?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelGroupSettingFilterInput | null > | null,
  or?: Array< ModelGroupSettingFilterInput | null > | null,
  not?: ModelGroupSettingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelGroupSettingConnection = {
  __typename: "ModelGroupSettingConnection",
  items:  Array<GroupSetting | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelGroupSettingByStatusCompositeKeyConditionInput = {
  eq?: ModelGroupSettingByStatusCompositeKeyInput | null,
  le?: ModelGroupSettingByStatusCompositeKeyInput | null,
  lt?: ModelGroupSettingByStatusCompositeKeyInput | null,
  ge?: ModelGroupSettingByStatusCompositeKeyInput | null,
  gt?: ModelGroupSettingByStatusCompositeKeyInput | null,
  between?: Array< ModelGroupSettingByStatusCompositeKeyInput | null > | null,
  beginsWith?: ModelGroupSettingByStatusCompositeKeyInput | null,
};

export type ModelGroupSettingByStatusCompositeKeyInput = {
  createdAt?: string | null,
  deleted?: string | null,
};

export type ModelTimelineFilterInput = {
  id?: ModelIDInput | null,
  actionName?: ModelStringInput | null,
  oldStatus?: ModelStringInput | null,
  newStatus?: ModelStringInput | null,
  bookingId?: ModelStringInput | null,
  customerId?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTimelineFilterInput | null > | null,
  or?: Array< ModelTimelineFilterInput | null > | null,
  not?: ModelTimelineFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTimelineConnection = {
  __typename: "ModelTimelineConnection",
  items:  Array<Timeline | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAdminRoleFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAdminRoleFilterInput | null > | null,
  or?: Array< ModelAdminRoleFilterInput | null > | null,
  not?: ModelAdminRoleFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAdminRoleConnection = {
  __typename: "ModelAdminRoleConnection",
  items:  Array<AdminRole | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelAdminGroupFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  roles?: ModelIDInput | null,
  users?: ModelIDInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAdminGroupFilterInput | null > | null,
  or?: Array< ModelAdminGroupFilterInput | null > | null,
  not?: ModelAdminGroupFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelAdminGroupConnection = {
  __typename: "ModelAdminGroupConnection",
  items:  Array<AdminGroup | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPointFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  amount?: ModelIntInput | null,
  expiry_date?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPointFilterInput | null > | null,
  or?: Array< ModelPointFilterInput | null > | null,
  not?: ModelPointFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPointConnection = {
  __typename: "ModelPointConnection",
  items:  Array<Point | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTierFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  starting_value?: ModelIntInput | null,
  is_points_expire?: ModelBooleanInput | null,
  welcome_points?: ModelIntInput | null,
  points_gain_factor?: ModelFloatInput | null,
  money_redeem_factor?: ModelFloatInput | null,
  days_to_expire?: ModelIntInput | null,
  discount_rate?: ModelIntInput | null,
  discount_simphony_id?: ModelStringInput | null,
  customerCount?: ModelIntInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTierFilterInput | null > | null,
  or?: Array< ModelTierFilterInput | null > | null,
  not?: ModelTierFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTierConnection = {
  __typename: "ModelTierConnection",
  items:  Array<Tier | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelTransactionFilterInput = {
  id?: ModelIDInput | null,
  accountID?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  customerID?: ModelStringInput | null,
  customerName?: ModelStringInput | null,
  checkNumber?: ModelStringInput | null,
  orderTotal?: ModelStringInput | null,
  paidAmount?: ModelFloatInput | null,
  discountAmount?: ModelFloatInput | null,
  employeeID?: ModelStringInput | null,
  employeeName?: ModelStringInput | null,
  revenueCentreName?: ModelStringInput | null,
  revenueCentreID?: ModelStringInput | null,
  points?: ModelIntInput | null,
  points_operation?: ModelStringInput | null,
  refundTrx?: ModelBooleanInput | null,
  refundAmount?: ModelFloatInput | null,
  paymentStatus?: ModelStringInput | null,
  itemNames?: ModelStringInput | null,
  itemCounts?: ModelIntInput | null,
  deleted?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByID?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTransactionFilterInput | null > | null,
  or?: Array< ModelTransactionFilterInput | null > | null,
  not?: ModelTransactionFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelTransactionConnection = {
  __typename: "ModelTransactionConnection",
  items:  Array<Transaction | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelOrderedItemsFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  itemName?: ModelStringInput | null,
  conceptID?: ModelStringInput | null,
  count?: ModelIntInput | null,
  isGlobal?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  createdByName?: ModelStringInput | null,
  deleted?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderedItemsFilterInput | null > | null,
  or?: Array< ModelOrderedItemsFilterInput | null > | null,
  not?: ModelOrderedItemsFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelOrderedItemsConnection = {
  __typename: "ModelOrderedItemsConnection",
  items:  Array<OrderedItems | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  conceptID?: ModelSubscriptionStringInput | null,
  username?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  email_verified?: ModelSubscriptionBooleanInput | null,
  phone_number?: ModelSubscriptionStringInput | null,
  phone_number_verified?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  nickname?: ModelSubscriptionStringInput | null,
  given_name?: ModelSubscriptionStringInput | null,
  middle_name?: ModelSubscriptionStringInput | null,
  family_name?: ModelSubscriptionStringInput | null,
  address?: ModelSubscriptionStringInput | null,
  birthdate?: ModelSubscriptionStringInput | null,
  gender?: ModelSubscriptionStringInput | null,
  picture?: ModelSubscriptionStringInput | null,
  website?: ModelSubscriptionStringInput | null,
  verification_code?: ModelSubscriptionStringInput | null,
  facebook?: ModelSubscriptionStringInput | null,
  instagram?: ModelSubscriptionStringInput | null,
  group?: ModelSubscriptionStringInput | null,
  phones?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  stats?: ModelSubscriptionIDInput | null,
  total_points?: ModelSubscriptionIntInput | null,
  points_history?: ModelSubscriptionIDInput | null,
  tier?: ModelSubscriptionIDInput | null,
  tier_name?: ModelSubscriptionStringInput | null,
  points_balance?: ModelSubscriptionFloatInput | null,
  total_spending?: ModelSubscriptionFloatInput | null,
  orders_count?: ModelSubscriptionIntInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionAccountFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  domain?: ModelSubscriptionStringInput | null,
  siteTitle?: ModelSubscriptionStringInput | null,
  guestsCount?: ModelSubscriptionIntInput | null,
  tagline?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  siteAddress?: ModelSubscriptionStringInput | null,
  defaultLanguage?: ModelSubscriptionStringInput | null,
  languages?: ModelSubscriptionStringInput | null,
  features?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  socialLinks?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  callCenterEmployeesIds?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAccountFilterInput | null > | null,
  or?: Array< ModelSubscriptionAccountFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  accountLogoId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionSocialLinkFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  icon?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSocialLinkFilterInput | null > | null,
  or?: Array< ModelSubscriptionSocialLinkFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFeatureFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  icon?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  precedence?: ModelSubscriptionStringInput | null,
  parent?: ModelSubscriptionStringInput | null,
  private?: ModelSubscriptionBooleanInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionFeatureFilterInput | null > | null,
  or?: Array< ModelSubscriptionFeatureFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionLanguageFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  code?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLanguageFilterInput | null > | null,
  or?: Array< ModelSubscriptionLanguageFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionMediaFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionIDInput | null,
  fileUrl?: ModelSubscriptionStringInput | null,
  filename?: ModelSubscriptionStringInput | null,
  filetype?: ModelSubscriptionStringInput | null,
  fileSize?: ModelSubscriptionIntInput | null,
  alternativeText?: ModelSubscriptionStringInput | null,
  caption?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  attachments?: ModelSubscriptionIDInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMediaFilterInput | null > | null,
  or?: Array< ModelSubscriptionMediaFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAttachmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  mediaID?: ModelSubscriptionIDInput | null,
  fileUrl?: ModelSubscriptionStringInput | null,
  filename?: ModelSubscriptionStringInput | null,
  filetype?: ModelSubscriptionStringInput | null,
  fileSize?: ModelSubscriptionIntInput | null,
  alternativeText?: ModelSubscriptionStringInput | null,
  caption?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAttachmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAttachmentFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionConceptFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  kiosks?: ModelSubscriptionIDInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionConceptFilterInput | null > | null,
  or?: Array< ModelSubscriptionConceptFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  color?: ModelSubscriptionStringInput | null,
  requireApproval?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  agents?: ModelSubscriptionStringInput | null,
  groupSettings?: ModelSubscriptionStringInput | null,
  numToUpgrade?: ModelSubscriptionIntInput | null,
  numToDowngrade?: ModelSubscriptionIntInput | null,
  upgradeGroup?: ModelSubscriptionIDInput | null,
  downgradeGroup?: ModelSubscriptionIDInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionGroupFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionGroupSettingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  groupID?: ModelSubscriptionStringInput | null,
  statusID?: ModelSubscriptionIDInput | null,
  needsVerification?: ModelSubscriptionBooleanInput | null,
  needsDeposit?: ModelSubscriptionBooleanInput | null,
  isDefault?: ModelSubscriptionBooleanInput | null,
  amount?: ModelSubscriptionIntInput | null,
  days?: ModelSubscriptionStringInput | null,
  timeSlots?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGroupSettingFilterInput | null > | null,
  or?: Array< ModelSubscriptionGroupSettingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTimelineFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  actionName?: ModelSubscriptionStringInput | null,
  oldStatus?: ModelSubscriptionStringInput | null,
  newStatus?: ModelSubscriptionStringInput | null,
  bookingId?: ModelSubscriptionStringInput | null,
  customerId?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTimelineFilterInput | null > | null,
  or?: Array< ModelSubscriptionTimelineFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAdminRoleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdminRoleFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdminRoleFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionAdminGroupFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  roles?: ModelSubscriptionIDInput | null,
  users?: ModelSubscriptionIDInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAdminGroupFilterInput | null > | null,
  or?: Array< ModelSubscriptionAdminGroupFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPointFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  amount?: ModelSubscriptionIntInput | null,
  expiry_date?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPointFilterInput | null > | null,
  or?: Array< ModelSubscriptionPointFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTierFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  conceptID?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  imageUrl?: ModelSubscriptionStringInput | null,
  starting_value?: ModelSubscriptionIntInput | null,
  is_points_expire?: ModelSubscriptionBooleanInput | null,
  welcome_points?: ModelSubscriptionIntInput | null,
  points_gain_factor?: ModelSubscriptionFloatInput | null,
  money_redeem_factor?: ModelSubscriptionFloatInput | null,
  days_to_expire?: ModelSubscriptionIntInput | null,
  discount_rate?: ModelSubscriptionIntInput | null,
  discount_simphony_id?: ModelSubscriptionStringInput | null,
  customerCount?: ModelSubscriptionIntInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTierFilterInput | null > | null,
  or?: Array< ModelSubscriptionTierFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionTransactionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  accountID?: ModelSubscriptionStringInput | null,
  conceptID?: ModelSubscriptionStringInput | null,
  customerID?: ModelSubscriptionStringInput | null,
  customerName?: ModelSubscriptionStringInput | null,
  checkNumber?: ModelSubscriptionStringInput | null,
  orderTotal?: ModelSubscriptionStringInput | null,
  paidAmount?: ModelSubscriptionFloatInput | null,
  discountAmount?: ModelSubscriptionFloatInput | null,
  employeeID?: ModelSubscriptionStringInput | null,
  employeeName?: ModelSubscriptionStringInput | null,
  revenueCentreName?: ModelSubscriptionStringInput | null,
  revenueCentreID?: ModelSubscriptionStringInput | null,
  points?: ModelSubscriptionIntInput | null,
  points_operation?: ModelSubscriptionStringInput | null,
  refundTrx?: ModelSubscriptionBooleanInput | null,
  refundAmount?: ModelSubscriptionFloatInput | null,
  paymentStatus?: ModelSubscriptionStringInput | null,
  itemNames?: ModelSubscriptionStringInput | null,
  itemCounts?: ModelSubscriptionIntInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByID?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  or?: Array< ModelSubscriptionTransactionFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionOrderedItemsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userID?: ModelSubscriptionStringInput | null,
  itemName?: ModelSubscriptionStringInput | null,
  conceptID?: ModelSubscriptionStringInput | null,
  count?: ModelSubscriptionIntInput | null,
  isGlobal?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  createdByName?: ModelSubscriptionStringInput | null,
  deleted?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderedItemsFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderedItemsFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAccountMutationVariables = {
  input: CreateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type CreateAccountMutation = {
  createAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type UpdateAccountMutationVariables = {
  input: UpdateAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type UpdateAccountMutation = {
  updateAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type DeleteAccountMutationVariables = {
  input: DeleteAccountInput,
  condition?: ModelAccountConditionInput | null,
};

export type DeleteAccountMutation = {
  deleteAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type CreateSocialLinkMutationVariables = {
  input: CreateSocialLinkInput,
  condition?: ModelSocialLinkConditionInput | null,
};

export type CreateSocialLinkMutation = {
  createSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateSocialLinkMutationVariables = {
  input: UpdateSocialLinkInput,
  condition?: ModelSocialLinkConditionInput | null,
};

export type UpdateSocialLinkMutation = {
  updateSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteSocialLinkMutationVariables = {
  input: DeleteSocialLinkInput,
  condition?: ModelSocialLinkConditionInput | null,
};

export type DeleteSocialLinkMutation = {
  deleteSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateFeatureMutationVariables = {
  input: CreateFeatureInput,
  condition?: ModelFeatureConditionInput | null,
};

export type CreateFeatureMutation = {
  createFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateFeatureMutationVariables = {
  input: UpdateFeatureInput,
  condition?: ModelFeatureConditionInput | null,
};

export type UpdateFeatureMutation = {
  updateFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteFeatureMutationVariables = {
  input: DeleteFeatureInput,
  condition?: ModelFeatureConditionInput | null,
};

export type DeleteFeatureMutation = {
  deleteFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateLanguageMutationVariables = {
  input: CreateLanguageInput,
  condition?: ModelLanguageConditionInput | null,
};

export type CreateLanguageMutation = {
  createLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateLanguageMutationVariables = {
  input: UpdateLanguageInput,
  condition?: ModelLanguageConditionInput | null,
};

export type UpdateLanguageMutation = {
  updateLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteLanguageMutationVariables = {
  input: DeleteLanguageInput,
  condition?: ModelLanguageConditionInput | null,
};

export type DeleteLanguageMutation = {
  deleteLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateMediaMutationVariables = {
  input: CreateMediaInput,
  condition?: ModelMediaConditionInput | null,
};

export type CreateMediaMutation = {
  createMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateMediaMutationVariables = {
  input: UpdateMediaInput,
  condition?: ModelMediaConditionInput | null,
};

export type UpdateMediaMutation = {
  updateMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteMediaMutationVariables = {
  input: DeleteMediaInput,
  condition?: ModelMediaConditionInput | null,
};

export type DeleteMediaMutation = {
  deleteMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAttachmentMutationVariables = {
  input: CreateAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type CreateAttachmentMutation = {
  createAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAttachmentMutationVariables = {
  input: UpdateAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type UpdateAttachmentMutation = {
  updateAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAttachmentMutationVariables = {
  input: DeleteAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type DeleteAttachmentMutation = {
  deleteAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateConceptMutationVariables = {
  input: CreateConceptInput,
  condition?: ModelConceptConditionInput | null,
};

export type CreateConceptMutation = {
  createConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateConceptMutationVariables = {
  input: UpdateConceptInput,
  condition?: ModelConceptConditionInput | null,
};

export type UpdateConceptMutation = {
  updateConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteConceptMutationVariables = {
  input: DeleteConceptInput,
  condition?: ModelConceptConditionInput | null,
};

export type DeleteConceptMutation = {
  deleteConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateGroupMutationVariables = {
  input: CreateGroupInput,
  condition?: ModelGroupConditionInput | null,
};

export type CreateGroupMutation = {
  createGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateGroupMutationVariables = {
  input: UpdateGroupInput,
  condition?: ModelGroupConditionInput | null,
};

export type UpdateGroupMutation = {
  updateGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteGroupMutationVariables = {
  input: DeleteGroupInput,
  condition?: ModelGroupConditionInput | null,
};

export type DeleteGroupMutation = {
  deleteGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateGroupSettingMutationVariables = {
  input: CreateGroupSettingInput,
  condition?: ModelGroupSettingConditionInput | null,
};

export type CreateGroupSettingMutation = {
  createGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateGroupSettingMutationVariables = {
  input: UpdateGroupSettingInput,
  condition?: ModelGroupSettingConditionInput | null,
};

export type UpdateGroupSettingMutation = {
  updateGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteGroupSettingMutationVariables = {
  input: DeleteGroupSettingInput,
  condition?: ModelGroupSettingConditionInput | null,
};

export type DeleteGroupSettingMutation = {
  deleteGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTimelineMutationVariables = {
  input: CreateTimelineInput,
  condition?: ModelTimelineConditionInput | null,
};

export type CreateTimelineMutation = {
  createTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTimelineMutationVariables = {
  input: UpdateTimelineInput,
  condition?: ModelTimelineConditionInput | null,
};

export type UpdateTimelineMutation = {
  updateTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTimelineMutationVariables = {
  input: DeleteTimelineInput,
  condition?: ModelTimelineConditionInput | null,
};

export type DeleteTimelineMutation = {
  deleteTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAdminRoleMutationVariables = {
  input: CreateAdminRoleInput,
  condition?: ModelAdminRoleConditionInput | null,
};

export type CreateAdminRoleMutation = {
  createAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdminRoleMutationVariables = {
  input: UpdateAdminRoleInput,
  condition?: ModelAdminRoleConditionInput | null,
};

export type UpdateAdminRoleMutation = {
  updateAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdminRoleMutationVariables = {
  input: DeleteAdminRoleInput,
  condition?: ModelAdminRoleConditionInput | null,
};

export type DeleteAdminRoleMutation = {
  deleteAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateAdminGroupMutationVariables = {
  input: CreateAdminGroupInput,
  condition?: ModelAdminGroupConditionInput | null,
};

export type CreateAdminGroupMutation = {
  createAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateAdminGroupMutationVariables = {
  input: UpdateAdminGroupInput,
  condition?: ModelAdminGroupConditionInput | null,
};

export type UpdateAdminGroupMutation = {
  updateAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteAdminGroupMutationVariables = {
  input: DeleteAdminGroupInput,
  condition?: ModelAdminGroupConditionInput | null,
};

export type DeleteAdminGroupMutation = {
  deleteAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePointMutationVariables = {
  input: CreatePointInput,
  condition?: ModelPointConditionInput | null,
};

export type CreatePointMutation = {
  createPoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePointMutationVariables = {
  input: UpdatePointInput,
  condition?: ModelPointConditionInput | null,
};

export type UpdatePointMutation = {
  updatePoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePointMutationVariables = {
  input: DeletePointInput,
  condition?: ModelPointConditionInput | null,
};

export type DeletePointMutation = {
  deletePoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTierMutationVariables = {
  input: CreateTierInput,
  condition?: ModelTierConditionInput | null,
};

export type CreateTierMutation = {
  createTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTierMutationVariables = {
  input: UpdateTierInput,
  condition?: ModelTierConditionInput | null,
};

export type UpdateTierMutation = {
  updateTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTierMutationVariables = {
  input: DeleteTierInput,
  condition?: ModelTierConditionInput | null,
};

export type DeleteTierMutation = {
  deleteTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateTransactionMutationVariables = {
  input: CreateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type CreateTransactionMutation = {
  createTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateTransactionMutationVariables = {
  input: UpdateTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type UpdateTransactionMutation = {
  updateTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteTransactionMutationVariables = {
  input: DeleteTransactionInput,
  condition?: ModelTransactionConditionInput | null,
};

export type DeleteTransactionMutation = {
  deleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateOrderedItemsMutationVariables = {
  input: CreateOrderedItemsInput,
  condition?: ModelOrderedItemsConditionInput | null,
};

export type CreateOrderedItemsMutation = {
  createOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateOrderedItemsMutationVariables = {
  input: UpdateOrderedItemsInput,
  condition?: ModelOrderedItemsConditionInput | null,
};

export type UpdateOrderedItemsMutation = {
  updateOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteOrderedItemsMutationVariables = {
  input: DeleteOrderedItemsInput,
  condition?: ModelOrderedItemsConditionInput | null,
};

export type DeleteOrderedItemsMutation = {
  deleteOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      accountID: string,
      conceptID?: string | null,
      username?: string | null,
      email?: string | null,
      email_verified?: boolean | null,
      phone_number?: string | null,
      phone_number_verified?: boolean | null,
      name?: string | null,
      nickname?: string | null,
      given_name?: string | null,
      middle_name?: string | null,
      family_name?: string | null,
      address?: string | null,
      birthdate?: string | null,
      gender?: string | null,
      picture?: string | null,
      website?: string | null,
      verification_code?: string | null,
      facebook?: string | null,
      instagram?: string | null,
      group?: string | null,
      phones?: Array< string | null > | null,
      status?: string | null,
      stats?: Array< string | null > | null,
      total_points?: number | null,
      points_history?: Array< string | null > | null,
      tier?: string | null,
      tier_name?: string | null,
      points_balance?: number | null,
      total_spending?: number | null,
      orders_count?: number | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUsersQuery = {
  syncUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      accountID: string,
      conceptID?: string | null,
      username?: string | null,
      email?: string | null,
      email_verified?: boolean | null,
      phone_number?: string | null,
      phone_number_verified?: boolean | null,
      name?: string | null,
      nickname?: string | null,
      given_name?: string | null,
      middle_name?: string | null,
      family_name?: string | null,
      address?: string | null,
      birthdate?: string | null,
      gender?: string | null,
      picture?: string | null,
      website?: string | null,
      verification_code?: string | null,
      facebook?: string | null,
      instagram?: string | null,
      group?: string | null,
      phones?: Array< string | null > | null,
      status?: string | null,
      stats?: Array< string | null > | null,
      total_points?: number | null,
      points_history?: Array< string | null > | null,
      tier?: string | null,
      tier_name?: string | null,
      points_balance?: number | null,
      total_spending?: number | null,
      orders_count?: number | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type UsersByEmailQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailQuery = {
  usersByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      accountID: string,
      conceptID?: string | null,
      username?: string | null,
      email?: string | null,
      email_verified?: boolean | null,
      phone_number?: string | null,
      phone_number_verified?: boolean | null,
      name?: string | null,
      nickname?: string | null,
      given_name?: string | null,
      middle_name?: string | null,
      family_name?: string | null,
      address?: string | null,
      birthdate?: string | null,
      gender?: string | null,
      picture?: string | null,
      website?: string | null,
      verification_code?: string | null,
      facebook?: string | null,
      instagram?: string | null,
      group?: string | null,
      phones?: Array< string | null > | null,
      status?: string | null,
      stats?: Array< string | null > | null,
      total_points?: number | null,
      points_history?: Array< string | null > | null,
      tier?: string | null,
      tier_name?: string | null,
      points_balance?: number | null,
      total_spending?: number | null,
      orders_count?: number | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type UsersByPhoneNumberQueryVariables = {
  phone_number: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByPhoneNumberQuery = {
  usersByPhoneNumber?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      accountID: string,
      conceptID?: string | null,
      username?: string | null,
      email?: string | null,
      email_verified?: boolean | null,
      phone_number?: string | null,
      phone_number_verified?: boolean | null,
      name?: string | null,
      nickname?: string | null,
      given_name?: string | null,
      middle_name?: string | null,
      family_name?: string | null,
      address?: string | null,
      birthdate?: string | null,
      gender?: string | null,
      picture?: string | null,
      website?: string | null,
      verification_code?: string | null,
      facebook?: string | null,
      instagram?: string | null,
      group?: string | null,
      phones?: Array< string | null > | null,
      status?: string | null,
      stats?: Array< string | null > | null,
      total_points?: number | null,
      points_history?: Array< string | null > | null,
      tier?: string | null,
      tier_name?: string | null,
      points_balance?: number | null,
      total_spending?: number | null,
      orders_count?: number | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type UserSortedByOrdersQueryVariables = {
  deleted: string,
  orders_count?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserSortedByOrdersQuery = {
  userSortedByOrders?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      accountID: string,
      conceptID?: string | null,
      username?: string | null,
      email?: string | null,
      email_verified?: boolean | null,
      phone_number?: string | null,
      phone_number_verified?: boolean | null,
      name?: string | null,
      nickname?: string | null,
      given_name?: string | null,
      middle_name?: string | null,
      family_name?: string | null,
      address?: string | null,
      birthdate?: string | null,
      gender?: string | null,
      picture?: string | null,
      website?: string | null,
      verification_code?: string | null,
      facebook?: string | null,
      instagram?: string | null,
      group?: string | null,
      phones?: Array< string | null > | null,
      status?: string | null,
      stats?: Array< string | null > | null,
      total_points?: number | null,
      points_history?: Array< string | null > | null,
      tier?: string | null,
      tier_name?: string | null,
      points_balance?: number | null,
      total_spending?: number | null,
      orders_count?: number | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAccountQueryVariables = {
  id: string,
};

export type GetAccountQuery = {
  getAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type ListAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAccountsQuery = {
  listAccounts?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      id: string,
      domain: string,
      siteTitle: string,
      guestsCount?: number | null,
      tagline: string,
      description: string,
      siteAddress: string,
      defaultLanguage: string,
      languages: Array< string | null >,
      features: Array< string | null >,
      status: string,
      socialLinks?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      callCenterEmployeesIds?: Array< string | null > | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      accountLogoId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAccountsQueryVariables = {
  filter?: ModelAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAccountsQuery = {
  syncAccounts?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      id: string,
      domain: string,
      siteTitle: string,
      guestsCount?: number | null,
      tagline: string,
      description: string,
      siteAddress: string,
      defaultLanguage: string,
      languages: Array< string | null >,
      features: Array< string | null >,
      status: string,
      socialLinks?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      callCenterEmployeesIds?: Array< string | null > | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      accountLogoId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AccountsByDomainQueryVariables = {
  domain: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AccountsByDomainQuery = {
  accountsByDomain?:  {
    __typename: "ModelAccountConnection",
    items:  Array< {
      __typename: "Account",
      id: string,
      domain: string,
      siteTitle: string,
      guestsCount?: number | null,
      tagline: string,
      description: string,
      siteAddress: string,
      defaultLanguage: string,
      languages: Array< string | null >,
      features: Array< string | null >,
      status: string,
      socialLinks?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      callCenterEmployeesIds?: Array< string | null > | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      accountLogoId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetSocialLinkQueryVariables = {
  id: string,
};

export type GetSocialLinkQuery = {
  getSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListSocialLinksQueryVariables = {
  filter?: ModelSocialLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSocialLinksQuery = {
  listSocialLinks?:  {
    __typename: "ModelSocialLinkConnection",
    items:  Array< {
      __typename: "SocialLink",
      id: string,
      name: string,
      icon: string,
      slug: string,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncSocialLinksQueryVariables = {
  filter?: ModelSocialLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncSocialLinksQuery = {
  syncSocialLinks?:  {
    __typename: "ModelSocialLinkConnection",
    items:  Array< {
      __typename: "SocialLink",
      id: string,
      name: string,
      icon: string,
      slug: string,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveLinksQueryVariables = {
  name: string,
  createdAtDeleted?: ModelSocialLinkByNameCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSocialLinkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveLinksQuery = {
  activeLinks?:  {
    __typename: "ModelSocialLinkConnection",
    items:  Array< {
      __typename: "SocialLink",
      id: string,
      name: string,
      icon: string,
      slug: string,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetFeatureQueryVariables = {
  id: string,
};

export type GetFeatureQuery = {
  getFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListFeaturesQueryVariables = {
  filter?: ModelFeatureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFeaturesQuery = {
  listFeatures?:  {
    __typename: "ModelFeatureConnection",
    items:  Array< {
      __typename: "Feature",
      id: string,
      name: string,
      icon?: string | null,
      slug: string,
      precedence: string,
      parent?: string | null,
      private?: boolean | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncFeaturesQueryVariables = {
  filter?: ModelFeatureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncFeaturesQuery = {
  syncFeatures?:  {
    __typename: "ModelFeatureConnection",
    items:  Array< {
      __typename: "Feature",
      id: string,
      name: string,
      icon?: string | null,
      slug: string,
      precedence: string,
      parent?: string | null,
      private?: boolean | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SearchFeaturesQueryVariables = {
  name: string,
  createdAtDeleted?: ModelFeatureByNameCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFeatureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type SearchFeaturesQuery = {
  searchFeatures?:  {
    __typename: "ModelFeatureConnection",
    items:  Array< {
      __typename: "Feature",
      id: string,
      name: string,
      icon?: string | null,
      slug: string,
      precedence: string,
      parent?: string | null,
      private?: boolean | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveFeaturesQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelFeatureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveFeaturesQuery = {
  activeFeatures?:  {
    __typename: "ModelFeatureConnection",
    items:  Array< {
      __typename: "Feature",
      id: string,
      name: string,
      icon?: string | null,
      slug: string,
      precedence: string,
      parent?: string | null,
      private?: boolean | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetLanguageQueryVariables = {
  id: string,
};

export type GetLanguageQuery = {
  getLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListLanguagesQueryVariables = {
  filter?: ModelLanguageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLanguagesQuery = {
  listLanguages?:  {
    __typename: "ModelLanguageConnection",
    items:  Array< {
      __typename: "Language",
      id: string,
      name: string,
      code: string,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncLanguagesQueryVariables = {
  filter?: ModelLanguageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncLanguagesQuery = {
  syncLanguages?:  {
    __typename: "ModelLanguageConnection",
    items:  Array< {
      __typename: "Language",
      id: string,
      name: string,
      code: string,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveLanguagesQueryVariables = {
  name: string,
  createdAtDeleted?: ModelLanguageByNameCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLanguageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveLanguagesQuery = {
  activeLanguages?:  {
    __typename: "ModelLanguageConnection",
    items:  Array< {
      __typename: "Language",
      id: string,
      name: string,
      code: string,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetMediaQueryVariables = {
  id: string,
};

export type GetMediaQuery = {
  getMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListMediaQueryVariables = {
  filter?: ModelMediaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMediaQuery = {
  listMedia?:  {
    __typename: "ModelMediaConnection",
    items:  Array< {
      __typename: "Media",
      id: string,
      accountID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      attachments?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncMediaQueryVariables = {
  filter?: ModelMediaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncMediaQuery = {
  syncMedia?:  {
    __typename: "ModelMediaConnection",
    items:  Array< {
      __typename: "Media",
      id: string,
      accountID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      attachments?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAttachmentQueryVariables = {
  id: string,
};

export type GetAttachmentQuery = {
  getAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAttachmentsQueryVariables = {
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttachmentsQuery = {
  listAttachments?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAttachmentsQueryVariables = {
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAttachmentsQuery = {
  syncAttachments?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetConceptQueryVariables = {
  id: string,
};

export type GetConceptQuery = {
  getConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListConceptsQueryVariables = {
  filter?: ModelConceptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListConceptsQuery = {
  listConcepts?:  {
    __typename: "ModelConceptConnection",
    items:  Array< {
      __typename: "Concept",
      id: string,
      accountID: string,
      name: string,
      kiosks?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncConceptsQueryVariables = {
  filter?: ModelConceptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncConceptsQuery = {
  syncConcepts?:  {
    __typename: "ModelConceptConnection",
    items:  Array< {
      __typename: "Concept",
      id: string,
      accountID: string,
      name: string,
      kiosks?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AccountConceptsQueryVariables = {
  accountID: string,
  createdAtDeleted?: ModelConceptByAccountCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelConceptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AccountConceptsQuery = {
  accountConcepts?:  {
    __typename: "ModelConceptConnection",
    items:  Array< {
      __typename: "Concept",
      id: string,
      accountID: string,
      name: string,
      kiosks?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetGroupQueryVariables = {
  id: string,
};

export type GetGroupQuery = {
  getGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListGroupsQueryVariables = {
  filter?: ModelGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGroupsQuery = {
  listGroups?:  {
    __typename: "ModelGroupConnection",
    items:  Array< {
      __typename: "Group",
      id: string,
      accountID: string,
      name: string,
      description?: string | null,
      color?: string | null,
      requireApproval?: boolean | null,
      status?: string | null,
      agents?: Array< string | null > | null,
      groupSettings?: Array< string | null > | null,
      numToUpgrade?: number | null,
      numToDowngrade?: number | null,
      upgradeGroup?: string | null,
      downgradeGroup?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncGroupsQueryVariables = {
  filter?: ModelGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncGroupsQuery = {
  syncGroups?:  {
    __typename: "ModelGroupConnection",
    items:  Array< {
      __typename: "Group",
      id: string,
      accountID: string,
      name: string,
      description?: string | null,
      color?: string | null,
      requireApproval?: boolean | null,
      status?: string | null,
      agents?: Array< string | null > | null,
      groupSettings?: Array< string | null > | null,
      numToUpgrade?: number | null,
      numToDowngrade?: number | null,
      upgradeGroup?: string | null,
      downgradeGroup?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type AccountGroupsQueryVariables = {
  accountID: string,
  createdAtDeleted?: ModelGroupByAccountCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AccountGroupsQuery = {
  accountGroups?:  {
    __typename: "ModelGroupConnection",
    items:  Array< {
      __typename: "Group",
      id: string,
      accountID: string,
      name: string,
      description?: string | null,
      color?: string | null,
      requireApproval?: boolean | null,
      status?: string | null,
      agents?: Array< string | null > | null,
      groupSettings?: Array< string | null > | null,
      numToUpgrade?: number | null,
      numToDowngrade?: number | null,
      upgradeGroup?: string | null,
      downgradeGroup?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveGroupsQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveGroupsQuery = {
  activeGroups?:  {
    __typename: "ModelGroupConnection",
    items:  Array< {
      __typename: "Group",
      id: string,
      accountID: string,
      name: string,
      description?: string | null,
      color?: string | null,
      requireApproval?: boolean | null,
      status?: string | null,
      agents?: Array< string | null > | null,
      groupSettings?: Array< string | null > | null,
      numToUpgrade?: number | null,
      numToDowngrade?: number | null,
      upgradeGroup?: string | null,
      downgradeGroup?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetGroupSettingQueryVariables = {
  id: string,
};

export type GetGroupSettingQuery = {
  getGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListGroupSettingsQueryVariables = {
  filter?: ModelGroupSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGroupSettingsQuery = {
  listGroupSettings?:  {
    __typename: "ModelGroupSettingConnection",
    items:  Array< {
      __typename: "GroupSetting",
      id: string,
      groupID: string,
      statusID: string,
      needsVerification: boolean,
      needsDeposit: boolean,
      isDefault: boolean,
      amount?: number | null,
      days?: Array< string | null > | null,
      timeSlots?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncGroupSettingsQueryVariables = {
  filter?: ModelGroupSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncGroupSettingsQuery = {
  syncGroupSettings?:  {
    __typename: "ModelGroupSettingConnection",
    items:  Array< {
      __typename: "GroupSetting",
      id: string,
      groupID: string,
      statusID: string,
      needsVerification: boolean,
      needsDeposit: boolean,
      isDefault: boolean,
      amount?: number | null,
      days?: Array< string | null > | null,
      timeSlots?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type StatusSettingsQueryVariables = {
  statusID: string,
  createdAtDeleted?: ModelGroupSettingByStatusCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGroupSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StatusSettingsQuery = {
  statusSettings?:  {
    __typename: "ModelGroupSettingConnection",
    items:  Array< {
      __typename: "GroupSetting",
      id: string,
      groupID: string,
      statusID: string,
      needsVerification: boolean,
      needsDeposit: boolean,
      isDefault: boolean,
      amount?: number | null,
      days?: Array< string | null > | null,
      timeSlots?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveGroupSettingsQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGroupSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveGroupSettingsQuery = {
  activeGroupSettings?:  {
    __typename: "ModelGroupSettingConnection",
    items:  Array< {
      __typename: "GroupSetting",
      id: string,
      groupID: string,
      statusID: string,
      needsVerification: boolean,
      needsDeposit: boolean,
      isDefault: boolean,
      amount?: number | null,
      days?: Array< string | null > | null,
      timeSlots?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTimelineQueryVariables = {
  id: string,
};

export type GetTimelineQuery = {
  getTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTimelinesQueryVariables = {
  filter?: ModelTimelineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTimelinesQuery = {
  listTimelines?:  {
    __typename: "ModelTimelineConnection",
    items:  Array< {
      __typename: "Timeline",
      id: string,
      actionName: string,
      oldStatus: string,
      newStatus: string,
      bookingId?: string | null,
      customerId?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTimelinesQueryVariables = {
  filter?: ModelTimelineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTimelinesQuery = {
  syncTimelines?:  {
    __typename: "ModelTimelineConnection",
    items:  Array< {
      __typename: "Timeline",
      id: string,
      actionName: string,
      oldStatus: string,
      newStatus: string,
      bookingId?: string | null,
      customerId?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveTimelinesQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTimelineFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveTimelinesQuery = {
  activeTimelines?:  {
    __typename: "ModelTimelineConnection",
    items:  Array< {
      __typename: "Timeline",
      id: string,
      actionName: string,
      oldStatus: string,
      newStatus: string,
      bookingId?: string | null,
      customerId?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAdminRoleQueryVariables = {
  id: string,
};

export type GetAdminRoleQuery = {
  getAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdminRolesQueryVariables = {
  filter?: ModelAdminRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdminRolesQuery = {
  listAdminRoles?:  {
    __typename: "ModelAdminRoleConnection",
    items:  Array< {
      __typename: "AdminRole",
      id: string,
      name?: string | null,
      description?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdminRolesQueryVariables = {
  filter?: ModelAdminRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdminRolesQuery = {
  syncAdminRoles?:  {
    __typename: "ModelAdminRoleConnection",
    items:  Array< {
      __typename: "AdminRole",
      id: string,
      name?: string | null,
      description?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveRolesQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAdminRoleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveRolesQuery = {
  activeRoles?:  {
    __typename: "ModelAdminRoleConnection",
    items:  Array< {
      __typename: "AdminRole",
      id: string,
      name?: string | null,
      description?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetAdminGroupQueryVariables = {
  id: string,
};

export type GetAdminGroupQuery = {
  getAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListAdminGroupsQueryVariables = {
  filter?: ModelAdminGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAdminGroupsQuery = {
  listAdminGroups?:  {
    __typename: "ModelAdminGroupConnection",
    items:  Array< {
      __typename: "AdminGroup",
      id: string,
      name?: string | null,
      description?: string | null,
      roles?: Array< string | null > | null,
      users?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncAdminGroupsQueryVariables = {
  filter?: ModelAdminGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncAdminGroupsQuery = {
  syncAdminGroups?:  {
    __typename: "ModelAdminGroupConnection",
    items:  Array< {
      __typename: "AdminGroup",
      id: string,
      name?: string | null,
      description?: string | null,
      roles?: Array< string | null > | null,
      users?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveAdminGroupsQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAdminGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveAdminGroupsQuery = {
  activeAdminGroups?:  {
    __typename: "ModelAdminGroupConnection",
    items:  Array< {
      __typename: "AdminGroup",
      id: string,
      name?: string | null,
      description?: string | null,
      roles?: Array< string | null > | null,
      users?: Array< string | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPointQueryVariables = {
  id: string,
};

export type GetPointQuery = {
  getPoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPointsQueryVariables = {
  filter?: ModelPointFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPointsQuery = {
  listPoints?:  {
    __typename: "ModelPointConnection",
    items:  Array< {
      __typename: "Point",
      id: string,
      accountID: string,
      amount?: number | null,
      expiry_date?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPointsQueryVariables = {
  filter?: ModelPointFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPointsQuery = {
  syncPoints?:  {
    __typename: "ModelPointConnection",
    items:  Array< {
      __typename: "Point",
      id: string,
      accountID: string,
      amount?: number | null,
      expiry_date?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActivePointsQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPointFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActivePointsQuery = {
  activePoints?:  {
    __typename: "ModelPointConnection",
    items:  Array< {
      __typename: "Point",
      id: string,
      accountID: string,
      amount?: number | null,
      expiry_date?: string | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTierQueryVariables = {
  id: string,
};

export type GetTierQuery = {
  getTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTiersQueryVariables = {
  filter?: ModelTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTiersQuery = {
  listTiers?:  {
    __typename: "ModelTierConnection",
    items:  Array< {
      __typename: "Tier",
      id: string,
      accountID: string,
      conceptID?: string | null,
      name: string,
      description?: string | null,
      imageUrl?: string | null,
      starting_value: number,
      is_points_expire?: boolean | null,
      welcome_points?: number | null,
      points_gain_factor?: number | null,
      money_redeem_factor?: number | null,
      days_to_expire?: number | null,
      discount_rate?: number | null,
      discount_simphony_id?: string | null,
      customerCount: number,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTiersQueryVariables = {
  filter?: ModelTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTiersQuery = {
  syncTiers?:  {
    __typename: "ModelTierConnection",
    items:  Array< {
      __typename: "Tier",
      id: string,
      accountID: string,
      conceptID?: string | null,
      name: string,
      description?: string | null,
      imageUrl?: string | null,
      starting_value: number,
      is_points_expire?: boolean | null,
      welcome_points?: number | null,
      points_gain_factor?: number | null,
      money_redeem_factor?: number | null,
      days_to_expire?: number | null,
      discount_rate?: number | null,
      discount_simphony_id?: string | null,
      customerCount: number,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveTiersQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveTiersQuery = {
  activeTiers?:  {
    __typename: "ModelTierConnection",
    items:  Array< {
      __typename: "Tier",
      id: string,
      accountID: string,
      conceptID?: string | null,
      name: string,
      description?: string | null,
      imageUrl?: string | null,
      starting_value: number,
      is_points_expire?: boolean | null,
      welcome_points?: number | null,
      points_gain_factor?: number | null,
      money_redeem_factor?: number | null,
      days_to_expire?: number | null,
      discount_rate?: number | null,
      discount_simphony_id?: string | null,
      customerCount: number,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetTransactionQueryVariables = {
  id: string,
};

export type GetTransactionQuery = {
  getTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTransactionsQuery = {
  listTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      accountID: string,
      conceptID?: string | null,
      customerID: string,
      customerName?: string | null,
      checkNumber: string,
      orderTotal: string,
      paidAmount?: number | null,
      discountAmount?: number | null,
      employeeID?: string | null,
      employeeName?: string | null,
      revenueCentreName?: string | null,
      revenueCentreID?: string | null,
      points?: number | null,
      points_operation?: string | null,
      refundTrx?: boolean | null,
      refundAmount?: number | null,
      paymentStatus?: string | null,
      itemNames?: Array< string | null > | null,
      itemCounts?: Array< number | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncTransactionsQueryVariables = {
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncTransactionsQuery = {
  syncTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      accountID: string,
      conceptID?: string | null,
      customerID: string,
      customerName?: string | null,
      checkNumber: string,
      orderTotal: string,
      paidAmount?: number | null,
      discountAmount?: number | null,
      employeeID?: string | null,
      employeeName?: string | null,
      revenueCentreName?: string | null,
      revenueCentreID?: string | null,
      points?: number | null,
      points_operation?: string | null,
      refundTrx?: boolean | null,
      refundAmount?: number | null,
      paymentStatus?: string | null,
      itemNames?: Array< string | null > | null,
      itemCounts?: Array< number | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type TransactionByUserQueryVariables = {
  customerID: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TransactionByUserQuery = {
  transactionByUser?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      accountID: string,
      conceptID?: string | null,
      customerID: string,
      customerName?: string | null,
      checkNumber: string,
      orderTotal: string,
      paidAmount?: number | null,
      discountAmount?: number | null,
      employeeID?: string | null,
      employeeName?: string | null,
      revenueCentreName?: string | null,
      revenueCentreID?: string | null,
      points?: number | null,
      points_operation?: string | null,
      refundTrx?: boolean | null,
      refundAmount?: number | null,
      paymentStatus?: string | null,
      itemNames?: Array< string | null > | null,
      itemCounts?: Array< number | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveTransactionsQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTransactionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveTransactionsQuery = {
  activeTransactions?:  {
    __typename: "ModelTransactionConnection",
    items:  Array< {
      __typename: "Transaction",
      id: string,
      accountID: string,
      conceptID?: string | null,
      customerID: string,
      customerName?: string | null,
      checkNumber: string,
      orderTotal: string,
      paidAmount?: number | null,
      discountAmount?: number | null,
      employeeID?: string | null,
      employeeName?: string | null,
      revenueCentreName?: string | null,
      revenueCentreID?: string | null,
      points?: number | null,
      points_operation?: string | null,
      refundTrx?: boolean | null,
      refundAmount?: number | null,
      paymentStatus?: string | null,
      itemNames?: Array< string | null > | null,
      itemCounts?: Array< number | null > | null,
      deleted?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetOrderedItemsQueryVariables = {
  id: string,
};

export type GetOrderedItemsQuery = {
  getOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListOrderedItemsQueryVariables = {
  filter?: ModelOrderedItemsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderedItemsQuery = {
  listOrderedItems?:  {
    __typename: "ModelOrderedItemsConnection",
    items:  Array< {
      __typename: "OrderedItems",
      id: string,
      userID: string,
      itemName: string,
      conceptID?: string | null,
      count: number,
      isGlobal?: string | null,
      createdAt: string,
      createdByName?: string | null,
      deleted?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncOrderedItemsQueryVariables = {
  filter?: ModelOrderedItemsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncOrderedItemsQuery = {
  syncOrderedItems?:  {
    __typename: "ModelOrderedItemsConnection",
    items:  Array< {
      __typename: "OrderedItems",
      id: string,
      userID: string,
      itemName: string,
      conceptID?: string | null,
      count: number,
      isGlobal?: string | null,
      createdAt: string,
      createdByName?: string | null,
      deleted?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ActiveOrdersQueryVariables = {
  deleted: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderedItemsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActiveOrdersQuery = {
  activeOrders?:  {
    __typename: "ModelOrderedItemsConnection",
    items:  Array< {
      __typename: "OrderedItems",
      id: string,
      userID: string,
      itemName: string,
      conceptID?: string | null,
      count: number,
      isGlobal?: string | null,
      createdAt: string,
      createdByName?: string | null,
      deleted?: string | null,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    accountID: string,
    conceptID?: string | null,
    username?: string | null,
    email?: string | null,
    email_verified?: boolean | null,
    phone_number?: string | null,
    phone_number_verified?: boolean | null,
    name?: string | null,
    nickname?: string | null,
    given_name?: string | null,
    middle_name?: string | null,
    family_name?: string | null,
    address?: string | null,
    birthdate?: string | null,
    gender?: string | null,
    picture?: string | null,
    website?: string | null,
    verification_code?: string | null,
    facebook?: string | null,
    instagram?: string | null,
    group?: string | null,
    phones?: Array< string | null > | null,
    status?: string | null,
    stats?: Array< string | null > | null,
    total_points?: number | null,
    points_history?: Array< string | null > | null,
    tier?: string | null,
    tier_name?: string | null,
    points_balance?: number | null,
    total_spending?: number | null,
    orders_count?: number | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
};

export type OnCreateAccountSubscription = {
  onCreateAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type OnUpdateAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
};

export type OnUpdateAccountSubscription = {
  onUpdateAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type OnDeleteAccountSubscriptionVariables = {
  filter?: ModelSubscriptionAccountFilterInput | null,
};

export type OnDeleteAccountSubscription = {
  onDeleteAccount?:  {
    __typename: "Account",
    id: string,
    logo?:  {
      __typename: "Attachment",
      id: string,
      mediaID: string,
      fileUrl: string,
      filename: string,
      filetype?: string | null,
      fileSize?: number | null,
      alternativeText?: string | null,
      caption?: string | null,
      description?: string | null,
      createdAt: string,
      createdByID: string,
      createdByName: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    domain: string,
    siteTitle: string,
    guestsCount?: number | null,
    tagline: string,
    description: string,
    siteAddress: string,
    defaultLanguage: string,
    languages: Array< string | null >,
    features: Array< string | null >,
    status: string,
    socialLinks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    callCenterEmployeesIds?: Array< string | null > | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    accountLogoId?: string | null,
  } | null,
};

export type OnCreateSocialLinkSubscriptionVariables = {
  filter?: ModelSubscriptionSocialLinkFilterInput | null,
};

export type OnCreateSocialLinkSubscription = {
  onCreateSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateSocialLinkSubscriptionVariables = {
  filter?: ModelSubscriptionSocialLinkFilterInput | null,
};

export type OnUpdateSocialLinkSubscription = {
  onUpdateSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteSocialLinkSubscriptionVariables = {
  filter?: ModelSubscriptionSocialLinkFilterInput | null,
};

export type OnDeleteSocialLinkSubscription = {
  onDeleteSocialLink?:  {
    __typename: "SocialLink",
    id: string,
    name: string,
    icon: string,
    slug: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateFeatureSubscriptionVariables = {
  filter?: ModelSubscriptionFeatureFilterInput | null,
};

export type OnCreateFeatureSubscription = {
  onCreateFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateFeatureSubscriptionVariables = {
  filter?: ModelSubscriptionFeatureFilterInput | null,
};

export type OnUpdateFeatureSubscription = {
  onUpdateFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteFeatureSubscriptionVariables = {
  filter?: ModelSubscriptionFeatureFilterInput | null,
};

export type OnDeleteFeatureSubscription = {
  onDeleteFeature?:  {
    __typename: "Feature",
    id: string,
    name: string,
    icon?: string | null,
    slug: string,
    precedence: string,
    parent?: string | null,
    private?: boolean | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateLanguageSubscriptionVariables = {
  filter?: ModelSubscriptionLanguageFilterInput | null,
};

export type OnCreateLanguageSubscription = {
  onCreateLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateLanguageSubscriptionVariables = {
  filter?: ModelSubscriptionLanguageFilterInput | null,
};

export type OnUpdateLanguageSubscription = {
  onUpdateLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteLanguageSubscriptionVariables = {
  filter?: ModelSubscriptionLanguageFilterInput | null,
};

export type OnDeleteLanguageSubscription = {
  onDeleteLanguage?:  {
    __typename: "Language",
    id: string,
    name: string,
    code: string,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateMediaSubscriptionVariables = {
  filter?: ModelSubscriptionMediaFilterInput | null,
};

export type OnCreateMediaSubscription = {
  onCreateMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateMediaSubscriptionVariables = {
  filter?: ModelSubscriptionMediaFilterInput | null,
};

export type OnUpdateMediaSubscription = {
  onUpdateMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteMediaSubscriptionVariables = {
  filter?: ModelSubscriptionMediaFilterInput | null,
};

export type OnDeleteMediaSubscription = {
  onDeleteMedia?:  {
    __typename: "Media",
    id: string,
    accountID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    attachments?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnCreateAttachmentSubscription = {
  onCreateAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnUpdateAttachmentSubscription = {
  onUpdateAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnDeleteAttachmentSubscription = {
  onDeleteAttachment?:  {
    __typename: "Attachment",
    id: string,
    mediaID: string,
    fileUrl: string,
    filename: string,
    filetype?: string | null,
    fileSize?: number | null,
    alternativeText?: string | null,
    caption?: string | null,
    description?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateConceptSubscriptionVariables = {
  filter?: ModelSubscriptionConceptFilterInput | null,
};

export type OnCreateConceptSubscription = {
  onCreateConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateConceptSubscriptionVariables = {
  filter?: ModelSubscriptionConceptFilterInput | null,
};

export type OnUpdateConceptSubscription = {
  onUpdateConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteConceptSubscriptionVariables = {
  filter?: ModelSubscriptionConceptFilterInput | null,
};

export type OnDeleteConceptSubscription = {
  onDeleteConcept?:  {
    __typename: "Concept",
    id: string,
    accountID: string,
    name: string,
    kiosks?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateGroupSubscriptionVariables = {
  filter?: ModelSubscriptionGroupFilterInput | null,
};

export type OnCreateGroupSubscription = {
  onCreateGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateGroupSubscriptionVariables = {
  filter?: ModelSubscriptionGroupFilterInput | null,
};

export type OnUpdateGroupSubscription = {
  onUpdateGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteGroupSubscriptionVariables = {
  filter?: ModelSubscriptionGroupFilterInput | null,
};

export type OnDeleteGroupSubscription = {
  onDeleteGroup?:  {
    __typename: "Group",
    id: string,
    accountID: string,
    name: string,
    description?: string | null,
    color?: string | null,
    requireApproval?: boolean | null,
    status?: string | null,
    agents?: Array< string | null > | null,
    groupSettings?: Array< string | null > | null,
    numToUpgrade?: number | null,
    numToDowngrade?: number | null,
    upgradeGroup?: string | null,
    downgradeGroup?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateGroupSettingSubscriptionVariables = {
  filter?: ModelSubscriptionGroupSettingFilterInput | null,
};

export type OnCreateGroupSettingSubscription = {
  onCreateGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateGroupSettingSubscriptionVariables = {
  filter?: ModelSubscriptionGroupSettingFilterInput | null,
};

export type OnUpdateGroupSettingSubscription = {
  onUpdateGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteGroupSettingSubscriptionVariables = {
  filter?: ModelSubscriptionGroupSettingFilterInput | null,
};

export type OnDeleteGroupSettingSubscription = {
  onDeleteGroupSetting?:  {
    __typename: "GroupSetting",
    id: string,
    groupID: string,
    statusID: string,
    needsVerification: boolean,
    needsDeposit: boolean,
    isDefault: boolean,
    amount?: number | null,
    days?: Array< string | null > | null,
    timeSlots?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTimelineSubscriptionVariables = {
  filter?: ModelSubscriptionTimelineFilterInput | null,
};

export type OnCreateTimelineSubscription = {
  onCreateTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTimelineSubscriptionVariables = {
  filter?: ModelSubscriptionTimelineFilterInput | null,
};

export type OnUpdateTimelineSubscription = {
  onUpdateTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTimelineSubscriptionVariables = {
  filter?: ModelSubscriptionTimelineFilterInput | null,
};

export type OnDeleteTimelineSubscription = {
  onDeleteTimeline?:  {
    __typename: "Timeline",
    id: string,
    actionName: string,
    oldStatus: string,
    newStatus: string,
    bookingId?: string | null,
    customerId?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAdminRoleSubscriptionVariables = {
  filter?: ModelSubscriptionAdminRoleFilterInput | null,
};

export type OnCreateAdminRoleSubscription = {
  onCreateAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAdminRoleSubscriptionVariables = {
  filter?: ModelSubscriptionAdminRoleFilterInput | null,
};

export type OnUpdateAdminRoleSubscription = {
  onUpdateAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAdminRoleSubscriptionVariables = {
  filter?: ModelSubscriptionAdminRoleFilterInput | null,
};

export type OnDeleteAdminRoleSubscription = {
  onDeleteAdminRole?:  {
    __typename: "AdminRole",
    id: string,
    name?: string | null,
    description?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateAdminGroupSubscriptionVariables = {
  filter?: ModelSubscriptionAdminGroupFilterInput | null,
};

export type OnCreateAdminGroupSubscription = {
  onCreateAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateAdminGroupSubscriptionVariables = {
  filter?: ModelSubscriptionAdminGroupFilterInput | null,
};

export type OnUpdateAdminGroupSubscription = {
  onUpdateAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteAdminGroupSubscriptionVariables = {
  filter?: ModelSubscriptionAdminGroupFilterInput | null,
};

export type OnDeleteAdminGroupSubscription = {
  onDeleteAdminGroup?:  {
    __typename: "AdminGroup",
    id: string,
    name?: string | null,
    description?: string | null,
    roles?: Array< string | null > | null,
    users?: Array< string | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePointSubscriptionVariables = {
  filter?: ModelSubscriptionPointFilterInput | null,
};

export type OnCreatePointSubscription = {
  onCreatePoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePointSubscriptionVariables = {
  filter?: ModelSubscriptionPointFilterInput | null,
};

export type OnUpdatePointSubscription = {
  onUpdatePoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePointSubscriptionVariables = {
  filter?: ModelSubscriptionPointFilterInput | null,
};

export type OnDeletePointSubscription = {
  onDeletePoint?:  {
    __typename: "Point",
    id: string,
    accountID: string,
    amount?: number | null,
    expiry_date?: string | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTierSubscriptionVariables = {
  filter?: ModelSubscriptionTierFilterInput | null,
};

export type OnCreateTierSubscription = {
  onCreateTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTierSubscriptionVariables = {
  filter?: ModelSubscriptionTierFilterInput | null,
};

export type OnUpdateTierSubscription = {
  onUpdateTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTierSubscriptionVariables = {
  filter?: ModelSubscriptionTierFilterInput | null,
};

export type OnDeleteTierSubscription = {
  onDeleteTier?:  {
    __typename: "Tier",
    id: string,
    accountID: string,
    conceptID?: string | null,
    name: string,
    description?: string | null,
    imageUrl?: string | null,
    starting_value: number,
    is_points_expire?: boolean | null,
    welcome_points?: number | null,
    points_gain_factor?: number | null,
    money_redeem_factor?: number | null,
    days_to_expire?: number | null,
    discount_rate?: number | null,
    discount_simphony_id?: string | null,
    customerCount: number,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnCreateTransactionSubscription = {
  onCreateTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnUpdateTransactionSubscription = {
  onUpdateTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteTransactionSubscriptionVariables = {
  filter?: ModelSubscriptionTransactionFilterInput | null,
};

export type OnDeleteTransactionSubscription = {
  onDeleteTransaction?:  {
    __typename: "Transaction",
    id: string,
    accountID: string,
    conceptID?: string | null,
    customerID: string,
    customerName?: string | null,
    checkNumber: string,
    orderTotal: string,
    paidAmount?: number | null,
    discountAmount?: number | null,
    employeeID?: string | null,
    employeeName?: string | null,
    revenueCentreName?: string | null,
    revenueCentreID?: string | null,
    points?: number | null,
    points_operation?: string | null,
    refundTrx?: boolean | null,
    refundAmount?: number | null,
    paymentStatus?: string | null,
    itemNames?: Array< string | null > | null,
    itemCounts?: Array< number | null > | null,
    orderedItems?:  Array< {
      __typename: "TransactionItem",
      symphonyID?: string | null,
      name: string,
      quantity: number,
      unitPrice?: number | null,
      totalPrice: number,
      refunded?: boolean | null,
    } | null > | null,
    deleted?: string | null,
    createdAt: string,
    createdByID: string,
    createdByName: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateOrderedItemsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderedItemsFilterInput | null,
};

export type OnCreateOrderedItemsSubscription = {
  onCreateOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateOrderedItemsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderedItemsFilterInput | null,
};

export type OnUpdateOrderedItemsSubscription = {
  onUpdateOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteOrderedItemsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderedItemsFilterInput | null,
};

export type OnDeleteOrderedItemsSubscription = {
  onDeleteOrderedItems?:  {
    __typename: "OrderedItems",
    id: string,
    userID: string,
    itemName: string,
    conceptID?: string | null,
    count: number,
    isGlobal?: string | null,
    createdAt: string,
    createdByName?: string | null,
    deleted?: string | null,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
